import React, { Fragment } from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import Header from '../components/Header'
import hero from '../images/our-technology__hero.jpg'
import img01 from '../images/our-technology-1.jpg'
import img02 from '../images/our-technology-2.jpg'
import img03 from '../images/our-technology-3.jpg'

import derbysoft from '../images/derbysoft.jpg'
import hbsi from '../images/hbsi.jpg'
import intuitive from '../images/intuitive.jpg'
import peakwork from '../images/peakwork.jpg'
import sabre from '../images/sabre.jpg'
import xmltravelgate from '../images/xmltravelgate.jpg'

import bestwestern from '../images/bestwestern.jpg'
import choice from '../images/choice.jpg'
import hilton from '../images/hilton.jpg'
import ihg from '../images/ihg.jpg'
import wyndham from '../images/wyndham.jpg'

const Page = () => (
  <Fragment>
    <Helmet
      title="Our Technology"
      // meta={[{ name: 'description', content: '' }]}
    />
    <Header hero={hero}>
      <h1 className="t-hero">Our Technology</h1>
    </Header>
    <main id="content">
      <div className="c-golden t-context--light">
        <div className="c-golden__content c-golden__wide">
          <ul className="c-breadcrumbs mb30">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/our-technology" activeClassName="is-active">
                Our Technology
              </Link>
            </li>
          </ul>
          <div className="c-golden__text">
            <div className="c-golden__text-col">
              <h1 className="t-h1">We Invest In Our Partners</h1>
              <p
                className="t-p t-p-light mt20 mb20"
                style={{ maxWidth: '50em' }}
              >
                Our proprietary technology is focused on our partners’ success,
                building custom web based platforms designed to optimize your
                ability to become North America travel specialists.
              </p>

             
              <h2 className="t-h2">ATI Website</h2>
              <p className="t-p t-p-light mt20 mb20"
                style={{ maxWidth: '50em' }}
              >
                Offering the ease of use for locating a vast product line of hotels,
                tours, excursions, and transportation options - our website works with
                you in mind. Providing fast and more efficient workflows, saving you
                time and thereby money, our booking engine builds upon our your
                expertise and enables you to enhance the trust of destination and
                product knowledge in front of your customer, while delivering the best
                rates in the industry.
              </p>

              <h2 className="t-h2">ATI Web Services</h2>
              <p className="t-p t-p-light mt20 mb20"
                style={{ maxWidth: '50em' }}
              >
                For clients with their own booking systems, our real-time, web service
                APIs, content data and caching technologies, we deliver travel data to
                your system with reliability, accuracy, and value, reducing your
                technical investment and lowering your costs.
              </p>
              
              <h2 className="t-h2">ATI Connected Partners</h2>
              <p className="t-p t-p-light mb20"/>

              <h3 className="t-h3">Travel Distributors and Integrators</h3>
              <p className="t-p t-p-light mt20 mb20"
                style={{ maxWidth: '50em' }}
              >
                <img src={derbysoft} alt="" style={{ width: '96px', height: '96px', marginRight: '36px' }} />
                <img src={hbsi} alt="" style={{ width: '96px', height: '96px', marginRight: '36px' }} />
                <img src={intuitive} alt="" style={{ width: '96px', height: '96px', marginRight: '36px' }} />
                <img src={peakwork} alt="" style={{ width: '96px', height: '96px', marginRight: '36px' }} />
                <img src={sabre} alt="" style={{ width: '96px', height: '96px', marginRight: '36px' }} />
                <img src={xmltravelgate} alt="" style={{ width: '96px', height: '96px', marginRight: '36px' }} />
                <h3 className="t-h3">and more...</h3>
              </p>
              <h3 className="t-h3">Global Hotel Chain Partners</h3>
              <p className="t-p t-p-light mt20 mb20"
                style={{ maxWidth: '50em' }}
              >
                <img src={bestwestern} alt="" style={{ width: '96px', height: '96px', marginRight: '36px' }} />
                <img src={choice} alt="" style={{ width: '96px', height: '96px', marginRight: '36px' }} />
                <img src={hilton} alt="" style={{ width: '96px', height: '96px', marginRight: '36px' }} />
                <img src={ihg} alt="" style={{ width: '96px', height: '96px', marginRight: '36px' }} />
                <img src={wyndham} alt="" style={{ width: '96px', height: '96px', marginRight: '36px' }} />
                <h3 className="t-h3">and more...</h3>
              </p>
            </div>
          </div>
        </div>
        <div className="c-golden__images c-golden__short min-laptop">
          <div style={{ width: '50%', height: '100%' }}>
            <img src={img02} alt="" style={{ width: '100%', height: '50%' }} />
            <img src={img03} alt="" style={{ width: '100%', height: '50%' }} />
          </div>
          <img src={img01} alt="" style={{ width: '50%', height: '100%' }} />
        </div>
      </div>
    </main>
  </Fragment>
)

export default Page



// WEBPACK FOOTER //
// ./src/pages/our-technology.js